import { render, staticRenderFns } from "./sortingCourse.vue?vue&type=template&id=447589e0"
import script from "./sortingCourse.vue?vue&type=script&lang=js"
export * from "./sortingCourse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports